var App = App || {};

App.SharedVideo = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            selector.each(function () {

                const video = $(this);

                // click to stop all other videos before playing the clicked video
                video.find(".partial-video__button").on("click", function () {
                    Play(video);
                });

                // if the video is in a modal, stop it from playing after modal close
                const modal = $(this).parents(".modal");
                if (modal.length > 0) {
                    modal.on("hidden.bs.modal", function () {
                        Stop(video);
                    });
                }

            });
        }
    }

    function Play(video) {

        // stop all other videos before starting a new one
        $(".partial-video").each(function () { Stop($(this)); });

        const target = video.find(".partial-video__placeholder");
        const button = video.find(".partial-video__button");
        const source = button.attr("data-src");
        const title = button.attr("data-title");

        switch (true) {
            case source.toLowerCase().indexOf("youtube") >= 0:
                target.html(Youtube(source, title))
                break;
            case source.toLowerCase().indexOf("vimeo") >= 0:
                target.html(Vimeo(source, title));
                break;
            default:
                console.log("Could not locate video content");
        };

        button.hide();
        target.show();
    }

    function Stop(video) {

        const target = video.find(".partial-video__placeholder");
        const button = video.find(".partial-video__button");

        target.hide().html("");
        button.show();
    }

    function Youtube(source, title) {
        var template = "<iframe src=\"" + source + "\" title=\"" + title + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
        return template;
    }

    function Vimeo(source, title) {
        var template = "<iframe src=\"" + source + "\" title=\"" + title + "\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>";
        return template;
    }

    return {
        Init: Init,
        Play: Play,
        Stop: Stop
    };

})(jQuery);
